import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { awaitWrap, OK } from '@/common';
import { batchChangePrice, submitGoods } from '@/api/goodsSetting';
import { passProduct, originPublishProduct } from '@/api/goodsJudge';
import { Modal, message } from 'ant-design-vue';
export function usePass(prodChnl, cb) {
  const gameGoodsList = ['weixin', 'kuaishou', '4399', 'alipay', 'zijie', 'BanHao', 'tiktok', 'blbl', 'meta'];
  const loading = ref(false); // loading
  // 同步商品数据留推送文案
  const syncProductSSEMessage = ref([]);
  // 推送loading状态
  const sseMessageLoading = ref(false);
  const sseMessageModal = ref(false);
  /*
   *  先提交商品，商品提交成功后才能提交审核
   *   自动通过审核，审核通过后才能发布
   *   发布商品，有可能只有部分商品发布成功
   * */
  const submitJudgeAndPass = async dataSource => {
    loading.value = true;
    const params = {
      productList: dataSource === null || dataSource === void 0 ? void 0 : dataSource.map(item => item.id),
      prodChnl: prodChnl.value
    };
    const [err, res] = await awaitWrap(submitGoods(params));
    if (err) return loading.value = false;
    if (res && res.code === OK) {
      // 自动审核通过
      const [err2, res2] = await awaitWrap(passProduct(params));
      if (err2) return loading.value = false;
      if (res2 && res2.code === OK) {
        if (gameGoodsList.includes(prodChnl.value)) {
          const [err3, res3] = await awaitWrap(originPublishProduct(params));
          if (err3) return loading.value = false;
          if (res3 && res3.code === OK) {
            message.success('提交成功');
            cb();
          } else if (res3 && res3.code === 500) {
            message.success(res3.msg);
            cb();
          }
        } else {
          syncProductSSE(dataSource);
        }
      }
      loading.value = false;
    }
  };
  // SSE长链接
  const syncProductSSE = async dataSource => {
    // 清空信息
    syncProductSSEMessage.value = [];
    sseMessageModal.value = true;
    sseMessageLoading.value = true;
    loading.value = true;
    syncProductSSEMessage.value.push('开始同步商品状态');
    // 准备POST请求数据
    const postData = {
      productList: dataSource === null || dataSource === void 0 ? void 0 : dataSource.map(item => item.id),
      prodChnl: prodChnl.value
    };
    try {
      var _response$body;
      // 发起POST请求
      const preUrl = process.env.VUE_APP_ISJOINT === 'true' && process.env.NODE_ENV === 'development' ? '' : process.env.VUE_APP_DOMAIN;
      const response = await fetch(`${preUrl}${preUrl !== null && preUrl !== void 0 && preUrl.endsWith('/') ? '' : '/'}${process.env.VUE_APP_SERVENAME}/product/publishProductSSE`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(postData)
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      // 获取响应的数据流
      const reader = (_response$body = response.body) === null || _response$body === void 0 ? void 0 : _response$body.getReader();
      if (!reader) {
        throw new Error('无法获取响应数据流');
      }
      // 用于解析不完整的行
      let partialLine = '';
      // 读取并处理数据流
      // eslint-disable-next-line no-constant-condition
      while (true) {
        const {
          done,
          value
        } = await reader.read();
        if (done) {
          break;
        }
        // 将二进制数据转换为文本
        const text = new TextDecoder().decode(value);
        const lines = (partialLine + text).split('\n');
        // 保存最后一行（可能不完整）
        partialLine = lines.pop() || '';
        // // 处理每一行数据
        for (const line of lines) {
          if (line.trim() === '') continue;
          // SSE格式通常是 "data: {json数据}"
          if (line.startsWith('event:')) {
            try {
              const jsonData = line.slice(6).trim();
              syncProductSSEMessage.value.push(jsonData);
              // 根据返回数据处理不同状态
              if (jsonData === 'complete') {
                sseMessageLoading.value = false;
              }
            } catch (e) {
              console.error('解析SSE消息失败:', e);
              syncProductSSEMessage.value.push(`解析SSE消息失败: ${e}`);
            }
          } else if (line.startsWith('data:')) {
            // 更新同一条消息，而不是创建新消息
            syncProductSSEMessage.value.push(line.slice(5).trim());
          }
        }
      }
    } catch (error) {
      console.error('SSE连接错误:', error);
      syncProductSSEMessage.value.push(`同步状态连接出错，请稍后重试，错误原因：${error}`);
    } finally {
      loading.value = false;
    }
  };
  const handleSSEMessageModalOk = () => {
    if (sseMessageLoading.value) {
      Modal.confirm({
        title: '提示',
        content: '关闭后无法查看同步最终结果，自行刷新页面查看',
        centered: true,
        okText: '确定',
        cancelText: '取消',
        maskClosable: false,
        onOk: () => {
          syncProductSSEMessage.value = [];
          sseMessageModal.value = false;
          cb();
        }
      });
    } else {
      syncProductSSEMessage.value = [];
      sseMessageModal.value = false;
    }
  };
  const changePrice = async (dataSource, changePriceType = 0) => {
    loading.value = true;
    const params = {
      productList: dataSource === null || dataSource === void 0 ? void 0 : dataSource.map(item => {
        return {
          id: item.id
        };
      }),
      changePriceType,
      prodChnl: prodChnl.value
    };
    const [err, res] = await awaitWrap(batchChangePrice(params));
    if (err) return loading.value = false;
    if (res && res.code === OK) {
      cb();
    }
    loading.value = false;
  };
  return {
    loading,
    submitJudgeAndPass,
    changePrice,
    handleSSEMessageModalOk,
    syncProductSSEMessage,
    sseMessageLoading,
    sseMessageModal
  };
}